<template>
  <div class="">
    <div class="flexbox info_box">
      <div class="flexbox info_top">
        <div class="flexbox">可用积分</div>
      </div>
      <div class="flexbox info_bottom">
        <span class="available">{{ info.available || 0 }}</span>
        <div class="unAcquire">待入账积分:{{ info.unAcquire || 0 }}</div>
        <!-- <img @click="popupVisible = true" src="../../../images/integral/log_icon.png" alt="" /> -->
      </div>
    </div>
    <van-popup v-model="popupVisible" class="border-popup">
      <div class="title-img">
        <img src="../../../images/integral/jfmxsm-title.png" alt="" />
      </div>
      <div class="pop_box">
        <ul class="tip_list_box">
          <li class="tip_item">
            <span class="dot"></span>
            <div class="tip_content">
              <div class="title">待入账</div>
              <div class="desc">邀请好友报名成功，但还未满足到账时间及条件，此状态下积分不可使用。</div>
            </div>
          </li>
          <li class="tip_item">
            <span class="dot"></span>
            <div class="tip_content">
              <div class="title">已入账</div>
              <div class="desc">完成学习任务或参加活动并满足条件。</div>
            </div>
          </li>
          <li class="tip_item">
            <span class="dot"></span>
            <div class="tip_content">
              <div class="title">已抵扣</div>
              <div class="desc">兑换商品使用的积分。</div>
            </div>
          </li>
          <li class="tip_item">
            <span class="dot"></span>
            <div class="tip_content">
              <div class="title">已退回</div>
              <div class="desc">使用积分兑换的商品退款后，退回的积分。</div>
            </div>
          </li>
          <li class="tip_item">
            <span class="dot"></span>
            <div class="tip_content">
              <div class="title">已取消</div>
              <div class="desc">积分在待入账状态下，邀请的好友申请退款，取消相应积分。</div>
            </div>
          </li>
        </ul>
        <ul class="flexbox action_box">
          <li @click="popupVisible = false">我知道了</li>
        </ul>
      </div>
    </van-popup>
  </div>
</template>

<script>
// import { appUser } from '@/utils'
// import { getPageUrl } from '@/utils/common/url'
import { $gotoPosterPage } from '@/utils/common/native-api'
import { integralName } from '@/pages/config'
export default {
  props: {
    info: {}
  },
  data() {
    return { integralName, popupVisible: false }
  },

  methods: {
    // 分享海报页面
    goCall() {
      $gotoPosterPage()
    }
  }
}
</script>

<style lang="less" scoped>
.border-popup {
  overflow: inherit;
  .title-img {
    width: 147px;
    margin: 0 auto;
    margin-top: -25px;
  }
}
.pop_box {
  width: 80vw;
  padding: 0 24px;
  .tip_list_box {
    margin-top: 0.16rem;
    .tip_item {
      display: flex;
      align-items: flex-start;
      gap: 0.16rem;
      padding: 0.12rem 0;
    }
    .dot {
      width: 0.16rem;
      height: 0.16rem;
      border-radius: 50%;
      background: #00b25a;
      margin-top: 0.12rem;
      flex-shrink: 0;
    }
    .tip_content {
      flex: 1;
    }
    .title {
      font-size: 0.3rem;
      font-weight: 600;
      color: #222;
      line-height: 1.4;
    }
    .desc {
      font-size: 0.26rem;
      color: #666;
      line-height: 1.8;
      margin-top: 0.06rem;
    }
  }
  .action_box {
    padding: 20px 0 20px;
    justify-content: space-around;
    li {
      width: 2rem;
      height: 0.7rem;
      text-align: center;
      line-height: 0.68rem;
      background-color: red;
      background: #ffffff;
      border: 1px solid #dddddd;
      border-radius: 6px;
      font-size: 0.26rem;
    }
    .color_box {
      background-color: #00b25a;
      color: #fff;
    }
  }
}
.pop_box {
  width: 80vw;
  padding: 0 24px;
  .pop_title_box {
    font-size: 0.36rem;
    font-weight: 600;
    text-align: center;
    padding: 0.48rem 0 0.2rem;
  }
  .action_box {
    padding: 20px 0 20px;
    justify-content: space-around;
    li {
      width: 2rem;
      height: 0.7rem;
      text-align: center;
      line-height: 0.68rem;
      background-color: red;
      background: #ffffff;
      border: 1px solid #dddddd;
      border-radius: 6px;
      font-size: 0.26rem;
    }
    .color_box {
      background-color: #00b25a;
      color: #fff;
    }
  }
}
.info_box {
  width: 100%;
  padding: 0.16rem 0.32rem 0.5rem;
  background: #00b25a;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  color: rgba(255, 255, 255, 0.8);
  .info_top {
    width: 100%;
    justify-content: space-between;
  }
  .info_bottom {
    margin-top: 0.08rem;
    display: flex;
    line-height: 1;
    align-items: flex-end;

    .available {
      color: #fff;
      font-size: 0.64rem;
      margin-right: 0.08rem;
    }
    .unAcquire {
      padding: 0.04rem 0;
    }
  }
}
</style>
